import { get } from 'lodash';
import { RootState } from 'store';
import { useAppSelector } from 'store/hooks';
import { IDEMOModelResDataItem } from '../interfaces/demoData';
import { PaginationResponse } from 'services/commonTypes';
import { IApiGetScreensParam, IScreen, ISummaryStats } from '../interfaces/api';

type MyState = RootState['dashboard'];
const getCurrentState = (state: RootState): MyState => state['dashboard'];

const selector = <T = MyState>(key: keyof T, defaultValue?: any) => useAppSelector(state => get(getCurrentState(state), key, defaultValue));

const getDemoData = () => selector('dataDemo') as IDEMOModelResDataItem[];
const getListScreens = () => selector('screensList') as PaginationResponse<IScreen> | null;
const getScreensParam = () => selector('screensParam') as IApiGetScreensParam;
const getSummaryStats = () => selector('summaryStats') as ISummaryStats;

const dashboardSelectors = {
  getDemoData,
  getListScreens,
  getScreensParam,
  getSummaryStats,
};
export default dashboardSelectors;
